<template>
  <div>
    <!-- 应用设置 -->
    <el-row>
      <el-col :span="24">
        <!-- 一般设置 -->
        <span class="secondfont-title">{{
          $t("message.applySettings.generalTitle")
        }}</span>
        <div>
          <el-row>
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{ $t("message.applySettings.scanSound") }}</span>
              <el-select class="short-form" size="medium" v-model="appSetting.play_sound.value">
                <el-option :label="$t('message.systemMsg.switchSelect.open')" value="true"></el-option>
                <el-option :label="$t('message.systemMsg.switchSelect.close')" value="false"></el-option>
              </el-select>
            </el-col>
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{ $t("message.applySettings.scanningLight") }}</span>
              <el-select class="short-form" size="medium" v-model="appSetting.play_scan_led.value">
                <el-option :label="$t('message.systemMsg.switchSelect.open')" value="true"></el-option>
                <el-option :label="$t('message.systemMsg.switchSelect.close')" value="false"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{ $t("message.applySettings.Vibration") }}</span>
              <el-select class="short-form" size="medium" v-model="appSetting.vibrate.value">
                <el-option :label="$t('message.systemMsg.switchSelect.open')" value="true"></el-option>
                <el-option :label="$t('message.systemMsg.switchSelect.close')" value="false"></el-option>
              </el-select>
            </el-col>
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{ $t("message.applySettings.barcodeAddition") }}</span>
              <el-select class="short-form" size="medium" v-model="appSetting.append.value">
                <el-option :label="$t('message.systemMsg.switchSelect.open')" value="true"></el-option>
                <el-option :label="$t('message.systemMsg.switchSelect.close')" value="false"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{ $t("message.applySettings.AutoEmptying") }}</span>
              <el-select class="short-form" size="medium" v-model="appSetting.auto_clear.value">
                <el-option :label="$t('message.systemMsg.switchSelect.open')" value="true"></el-option>
                <el-option :label="$t('message.systemMsg.switchSelect.close')" value="false"></el-option>
              </el-select>
            </el-col>
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{ $t("message.applySettings.startUpAuto") }}</span>
              <el-select class="short-form" size="medium" v-model="appSetting.boot_start.value">
                <el-option :label="$t('message.systemMsg.switchSelect.open')" value="true"></el-option>
                <el-option :label="$t('message.systemMsg.switchSelect.close')" value="false"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{
                $t("message.applySettings.displayBarcodeType")
              }}</span>
              <el-select class="short-form" size="medium" v-model="appSetting.show_barcode_type.value">
                <el-option :label="$t('message.systemMsg.switchSelect.open')" value="true"></el-option>
                <el-option :label="$t('message.systemMsg.switchSelect.close')" value="false"></el-option>
              </el-select>
            </el-col>
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{
                $t("message.applySettings.filterInvisibleCharacters")
              }}</span>
              <el-select class="short-form" size="medium" v-model="appSetting.filter_invisible_chars.value">
                <el-option :label="$t('message.systemMsg.switchSelect.open')" value="true"></el-option>
                <el-option :label="$t('message.systemMsg.switchSelect.close')" value="false"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{
                $t("message.applySettings.convertInvisibleCharacters")
              }}</span>
              <el-select class="short-form" size="medium" v-model="appSetting.convert_invisible_chars.value">
                <el-option :label="$t('message.systemMsg.switchSelect.open')" value="true"></el-option>
                <el-option :label="$t('message.systemMsg.switchSelect.close')" value="false"></el-option>
              </el-select>
            </el-col>
            <!-- 字符串设置 -->
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{
                $t("message.applySettings.characterSubstitutionSettings")
              }}</span>
              <el-button type="text" @click="openStringDialog">{{
                $t("message.applySettings.setUp") }}</el-button>
            </el-col>
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{ $t("message.applySettings.filterBarcode") }}</span>
              <el-select class="short-form" size="medium" v-model="appSetting.filter_prefix_suffix_blank.value">
                <el-option :label="$t('message.systemMsg.switchSelect.open')" value="true"></el-option>
                <el-option :label="$t('message.systemMsg.switchSelect.close')" value="false"></el-option>
              </el-select>
            </el-col>
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{ $t("message.applySettings.BarcodeSuspensionSetting") }}
              </span>
              <el-select class="short-form" size="medium" v-model="appSetting.show_barcode_toast.value">
                <el-option :label="$t('message.systemMsg.switchSelect.open')" value="true"></el-option>
                <el-option :label="$t('message.systemMsg.switchSelect.close')" value="false"></el-option>
              </el-select>
            </el-col>
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{
                $t("message.applySettings.enableScanningStatistics")
              }}</span>
              <el-select class="short-form" size="medium" v-model="appSetting.ope_scan_statistics.value">
                <el-option :label="$t('message.systemMsg.switchSelect.open')" value="true"></el-option>
                <el-option :label="$t('message.systemMsg.switchSelect.close')" value="false"></el-option>
              </el-select>
            </el-col>
            <!-- 循环扫描间隔 -->
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{
                $t("message.applySettings.cycleScanInterval")
              }}</span>
              <el-button type="text" @click="openScanDialog">{{
                $t("message.applySettings.setUp") }}</el-button>
            </el-col>
            <!-- 多条码设置 -->
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{ $t("message.applySettings.MultiBarcode") }}</span>
              <el-button type="text" @click="openMoreCodeDialog">{{
                $t("message.applySettings.setUp") }}</el-button>
            </el-col>
            <!-- 条码截断 -->
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{
                $t("message.applySettings.BarcodeTruncation")
              }}</span>
              <el-button type="text" @click="openbarTruDialog">{{
                $t("message.applySettings.setUp") }}</el-button>
            </el-col>

            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{
                $t("message.applySettings.MultiBarcodeDisplay")
              }}</span>
              <el-select class="short-form" size="medium" v-model="appSetting.show_multi_code_scan_float.value">
                <el-option :label="$t('message.systemMsg.switchSelect.open')" value="true"></el-option>
                <el-option :label="$t('message.systemMsg.switchSelect.close')" value="false"></el-option>
              </el-select>
            </el-col>

            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{ $t("message.applySettings.barcodeSuffix") }}</span>
              <el-input size="medium" v-model="appSetting.suffix.value"></el-input>
            </el-col>
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{ $t("message.applySettings.barcodePrefix") }}</span>
              <el-input size="medium" v-model="appSetting.prefix.value"></el-input>
            </el-col>

            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{ $t("message.applySettings.Terminator") }}</span>
              <el-select size="medium" class="short-form" v-model="appSetting.end_char.value">
                <el-option label="ENTER" value="ENTER"></el-option>
                <el-option label="TAB" value="TAB"></el-option>
                <el-option label="SPACE" value="SPACE"></el-option>
                <el-option label="CR_LF" value="CR_LF"></el-option>
                <el-option label="NONE" value="NONE"></el-option>
              </el-select>
            </el-col>
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{ $t("message.applySettings.characterSet") }}</span>
              <el-select size="medium" class="short-form" v-model="appSetting.charset.value">
                <el-option label="AutoDetect" value="AutoDetect"></el-option>
                <el-option label="Raw" value="Raw"></el-option>
                <el-option label="GBK" value="GBK"></el-option>
                <el-option label="GB2312" value="GB2312"></el-option>
                <el-option label="UTF8" value="UTF8"></el-option>
                <el-option label="BIG5" value="BIG5"></el-option>
                <el-option label="SJIS" value="SJIS"></el-option>
                <el-option label="EUC_JP" value="EUC_JP"></el-option>
                <el-option label="ISO8859_1" value="ISO8859_1"></el-option>
                <el-option label="WINDOWS_874" value="WINDOWS_874"></el-option>
              </el-select>
            </el-col>
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{ $t("message.applySettings.triggerMode") }}</span>
              <el-select size="medium" class="short-form" v-model="appSetting.advanced_trigger_mode.value">
                <el-option :label="$t('message.applySettings.ssrhs')" value="1"></el-option>
                <el-option :label="$t('message.applySettings.singleScan')" value="2"></el-option>
                <el-option :label="$t('message.applySettings.sshs')" value="3"></el-option>
                <el-option :label="$t('message.applySettings.ssdps')" value="4"></el-option>
                <el-option :label="$t('message.applySettings.cspas')" value="5"></el-option>
                <el-option :label="$t('message.applySettings.continuousLighting')" value="6"></el-option>
                <el-option :label="$t('message.applySettings.clhls')" value="7"></el-option>
                <el-option :label="$t('message.applySettings.MultiBarcodeScanning')" value="8"></el-option>
                <el-option :label="$t('message.applySettings.mbsrhr')" value="9"></el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
        <!-- 条码发送 -->
        <el-row>
          <span class="secondfont-title">{{ $t("message.applySettings.BarcodeSending") }}</span>
          <el-row>
            <el-col :span="10" class="setting-box">
              <el-radio-group v-model="appSetting.send_mode.value" @change="changeRadioButton($event)">
                <el-radio-button label="FOCUS">{{ $t("message.applySettings.FocusEntry") }}</el-radio-button>
                <el-radio-button label="BROADCAST">{{ $t("message.applySettings.broadcast") }}</el-radio-button>
                <el-radio-button label="EMUKEY">{{ $t("message.applySettings.AnalogKey") }}</el-radio-button>
                <el-radio-button label="CLIPBOARD">{{ $t("message.applySettings.clipboard") }}</el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row v-show="foucsFlag">
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{ $t("message.applySettings.terminatorKey") }}</span>
              <el-select size="medium" v-model="appSetting.end_char_on_emu.value">
                <el-option :label="$t('message.systemMsg.switchSelect.open')" value="true"></el-option>
                <el-option :label="$t('message.systemMsg.switchSelect.close')" value="false"></el-option>
              </el-select>
            </el-col>
            <el-col :span="10" class="setting-box">
              <span class="setTitle">{{ $t("message.applySettings.autoSubmit") }}</span>
              <el-select size="medium" v-model="appSetting.auto_commit_on_emu.value">
                <el-option :label="$t('message.systemMsg.switchSelect.open')" value="true"></el-option>
                <el-option :label="$t('message.systemMsg.switchSelect.close')" value="false"></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-row>
        <!-- 其他 -->
        <el-row>
          <el-col :span="24">
            <span class="secondfont-title">{{ $t("message.applySettings.DeveloperItem") }}</span>
          </el-col>
          <el-col :span="24">
            <span class="small-font">{{ $t("message.applySettings.BroadcastCustomization") }}</span>
            <div>
              <el-row>
                <el-col :span="10" class="setting-box">
                  <span class="setTitle">{{ $t("message.applySettings.BroadcastName") }}</span>
                  <el-input size="medium" v-model="appSetting.barcode_broadcast_name.value"></el-input>
                </el-col>
                <el-col :span="10" class="setting-box">
                  <span class="setTitle">{{ $t("message.applySettings.KeyValueName") }}</span>
                  <el-input size="medium" v-model="appSetting.barcode_broadcast_key.value"></el-input>
                </el-col>
                <el-col :span="10" class="setting-box">
                  <span class="setTitle">{{ $t("message.applySettings.StartScanBroadcast") }}</span>
                  <el-input size="medium" v-model="appSetting.start_scan_broadcast_name.value"></el-input>
                </el-col>
                <el-col :span="10" class="setting-box">
                  <span class="setTitle">{{ $t("message.applySettings.StopScanBroadcast") }}</span>
                  <el-input size="medium" v-model="appSetting.start_stop_broadcast_name.value"></el-input>
                </el-col>
                <el-col :span="10" class="setting-box">
                  <span class="setTitle">{{ $t("message.applySettings.carriageReturnTime") }}</span>
                  <el-select size="medium" v-model="appSetting.end_event.value">
                    <el-option :label="$t('message.systemMsg.switchSelect.open')" value="true"></el-option>
                    <el-option :label="$t('message.systemMsg.switchSelect.close')" value="false"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="24">
            <span class="small-font">{{ $t("message.applySettings.ScanKeyShield") }}</span>
            <div>
              <el-row>
                <el-col :span="10" class="setting-box">
                  <span class="setTitle">{{ $t("message.applySettings.ScanKeyMask") }}</span>
                  <el-input size="medium" placeholder="248,249,250" v-model="appSetting.block_scan_key_list.value"></el-input>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="24">
            <span class="small-font">{{ $t("message.applySettings.SetUniversalPassword") }}</span>
            <div>
              <el-row>
                <el-col :span="10" class="setting-box">
                  <span class="setTitle">{{ $t("message.applySettings.GeneralPassword") }}</span>
                  <el-input size="medium" v-model="appSetting.password_md5.value"></el-input>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!-- 循环扫描间隔 start -->
    <el-dialog :title="$t('message.applySettings.cycleScanInterval')" :visible.sync="scandialogVisible" width="40%"
      @close="scanCloseDialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="appscanCopy" label-width="180px" ref="scanForm">
        <el-form-item :label="$t('messageAdd.app.001')">
          <el-radio-group v-model="appscanCopy.scan_continue_internal_mode.value" @change="handleAppScanChange">
            <el-radio :label="0">{{ $t("message.applySettings.NormalMode1") }}</el-radio>
            <el-radio :label="1">{{ $t("message.applySettings.EnhancedMode1") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.app.002')" v-if="appscanCopy.scan_continue_internal_mode.value === 0">
          <el-input v-model="appscanCopy.scan_continue_normal_internal.value"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.app.003')" v-if="appscanCopy.scan_continue_internal_mode.value === 1">
          <el-input v-model="appscanCopy.scan_continue_no_data_internal.value"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageAdd.app.004')" v-if="appscanCopy.scan_continue_internal_mode.value === 1">
          <el-input v-model="appscanCopy.scan_continue_with_data_internal.value"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="setCircleScan">{{ $t("message.applySettings.Submit") }}</el-button>
      </span>
    </el-dialog>
    <!-- 循环扫描间隔 end -->
    <!-- 字符替换 start -->
    <el-dialog :title="$t('message.applySettings.CharacterSubstitution')" :visible.sync="stringdialogVisible"
      width="40%" :close-on-click-modal="false" :close-on-press-escape="false" @close="strDialogClose">
      <div style="width: 100%">
        <el-button type="text" size="small" icon="el-icon-circle-plus-outline" @click="addChangeStr">{{ $t("message.applySettings.add") }}</el-button>
      </div>
      <el-table border :data="changeStr">
        <el-table-column prop="id" :label="$t('message.applySettings.index')" width="80" type="index" align="center" />
        <el-table-column prop="source" align="center" :label="$t('message.applySettings.SourceCharacter')">
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.source }}</span>
            <el-select v-model="scope.row.source" v-show="scope.row.isEdit" allow-create :multiple-limit="1" filterable :placeholder="$t('message.messageMsg.CustomSource')">
              <el-option value="GS" label="GS"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="replace" align="center" :label="$t('message.applySettings.ReplaceCharacter')">
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.replace }}</span>
            <el-input v-show="scope.row.isEdit" v-model="scope.row.replace"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('message.applySettings.operation')" align="center">
          <template slot-scope="scope">
            <el-button size="small" type="text" v-show="scope.row.isEdit" @click="okChangeStr(scope.row)">{{ $t("message.applySettings.Submit") }}</el-button>
            <el-button size="small" type="primary" icon="el-icon-edit" @click="editChangeStr(scope.row)" v-show="!scope.row.isEdit"></el-button>
            <el-button size="small" type="danger" icon="el-icon-delete" @click="delChangeStr(scope.row)" v-show="!scope.row.isEdit"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitStr">{{ $t("message.applySettings.Submit") }}</el-button>
      </span>
    </el-dialog>
    <!-- 字符替换 end -->
    <!-- 多条码 start -->
    <el-dialog :title="$t('message.applySettings.MultiBarcode')" :visible.sync="moreCodedialogVisible" width="40%"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form label-width="200px" style="margin-right: 100px" :model="multiCopy">
        <el-form-item :label="$t('message.applySettings.BarcodeSplicing')">
          <el-radio-group v-model="multiCopy.multi_code_normal_splicing.value" @change="changeNumalMultiCode">
            <el-radio :label="true">{{ $t("message.applySettings.open") }}</el-radio>
            <el-radio :label="false">{{ $t("message.applySettings.close") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('message.applySettings.Separator')" v-show="multiCopy.multi_code_normal_splicing.value">
          <el-select v-model="multiCopy.multi_code_normal_separator.value" allow-create :multiple-limit="1" filterable :placeholder="$t('message.messageMsg.multiMag')">
            <el-option value=";" label=";"></el-option>
            <el-option value="," label=","></el-option>
            <el-option value="" :label="$t('message.applySettings.NoSeparator')"></el-option>
            <el-option value=" " :label="$t('message.applySettings.Space')"></el-option>
            <el-option value="\n" :label="$t('message.applySettings.LineBreak')"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.applySettings.Code128')">
          <el-radio-group v-model="multiCopy.multi_code_gs1128_splicing.value" @change="changeGS128MultiCode">
            <el-radio :label="true">{{ $t("message.applySettings.open") }}</el-radio>
            <el-radio :label="false">{{ $t("message.applySettings.close") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('message.applySettings.Separator')" v-show="multiCopy.multi_code_gs1128_splicing.value">
          <el-select v-model="multiCopy.multi_code_gs1128_separator.value" allow-create :multiple-limit="1" filterable :placeholder="$t('message.messageMsg.multiMag')">
            <el-option value=";" label=";"></el-option>
            <el-option value="," label=","></el-option>
            <el-option value="" :label="$t('message.applySettings.NoSeparator')"></el-option>
            <el-option value=" " :label="$t('message.applySettings.Space')"></el-option>
            <el-option value="\n" :label="$t('message.applySettings.LineBreak')"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="setMulti">{{ $t("message.applySettings.Submit") }}</el-button>
      </span>
    </el-dialog>
    <!-- 多条码 end -->
    <!-- 条码截断 start-->
    <el-dialog :title="$t('message.applySettings.BarcodeTruncation')" :visible.sync="barcodeTruDialog" width="40%"
      @close="splitCloseDialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form label-width="150px" :model="spliteBarcodeCopy">
        <el-form-item :label="$t('message.applySettings.BarcodeTruncation')">
          <el-radio-group v-model="spliteBarcodeCopy.split_barcode_mode.value" @change="handleSpliteBarcodeChange">
            <el-radio :label="0">{{ $t("message.applySettings.IndexMode") }}</el-radio>
            <el-radio :label="1">{{ $t("message.applySettings.CharacterMode") }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-form v-show="spliteBarcodeCopy.split_barcode_mode.value === 0" label-width="120px" style="width: 90%"
        :model="spliteBarcodeCopy" ref="splitForm1">
        <el-form-item :label="$t('message.applySettings.StartIndex')" prop="start_index.value">
          <el-input v-model="spliteBarcodeCopy.start_index.value" :placeholder="$t('message.messageMsg.numBig0')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.applySettings.EndIndex')" prop="end_index.value">
          <el-input v-model="spliteBarcodeCopy.end_index.value" :placeholder="$t('message.messageMsg.numBig0')"></el-input>
        </el-form-item>
      </el-form>
      <el-form label-width="120px" v-show="spliteBarcodeCopy.split_barcode_mode.value === 1" style="width: 90%"
        :model="spliteBarcodeCopy" ref="splitForm2">
        <el-form-item :label="$t('message.applySettings.StartCharacter')" prop="start_char.value">
          <el-input v-model="spliteBarcodeCopy.start_char.value" :placeholder="$t('message.messageMsg.inputSingleChar')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.applySettings.EndCharacter')" prop="end_char.value">
          <el-input v-model="spliteBarcodeCopy.end_char.value" :placeholder="$t('message.messageMsg.inputSingleChar')"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitBarTru">{{ $t("message.applySettings.Submit") }}</el-button>
      </span>
    </el-dialog>
    <!-- 条码截断 end -->
    <!-- 弹框 end -->
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import md5 from 'js-md5'; // 引入md5函数
export default {
  props: {
    appSettingDataNoFilter: {
      type: Object
    },
    deleteAllAppData: {
      type: Boolean
    }
  },
  data() {
    return {
      // 循环扫描间隔
      appscanCopy: {
        scan_continue_internal_mode: {
          type: "int",
          value: "",
        },
        scan_continue_normal_internal: {
          type: "int",
          value: "",
        },
        scan_continue_no_data_internal: {
          type: "int",
          value: "",
        },
        scan_continue_with_data_internal: {
          type: "int",
          value: "",
        },
      },
      // 多条码
      multiCopy: {
        multi_code_normal_splicing: {
          type: "boolean",
          value: "",
        },
        multi_code_normal_separator: {
          type: "string",
          value: "",
        },
        multi_code_gs1128_splicing: {
          type: "boolean",
          value: "",
        },
        multi_code_gs1128_separator: {
          type: "string",
          value: "",
        },
      },
      // 条码截断
      spliteBarcodeCopy: {
        split_barcode_mode: {
          type: "int",
          value: "",
        },
        start_index: {
          type: "int",
          value: "",
        },
        end_index: {
          type: "int",
          value: "",
        },
        start_char: {
          type: "string",
          value: "",
        },
        end_char: {
          type: "string",
          value: "",
        },
      },
      barcodeTruDialog: false,
      pwd: "",
      foucsFlag: false,
      changeStr: [],
      broadcastFlag: false,
      emukeyFlag: false,
      clipboardFlag: false,
      scandialogVisible: false,
      stringdialogVisible: false,
      moreCodedialogVisible: false,
      stringNum: 0,
    };
  },
  computed: {
    appSetting() {
      return this.appSettingDataNoFilter;
    }
  },
  watch: {
    appSetting: {
      handler() {
        this.createLocalStorageData();
      },
      deep: true,
      immediate: true,
    },
    "$i18n.locale": function () {
      this.setFormRules();
    },
  },
  mounted() {
    this.setFormRules();
  },
  methods: {
    createLocalStorageData() {
      // 处理密码加密，将appSetting.password_md5.value  使用md5加密
      const d = { ...cloneDeep(this.appSetting) };
      if (d.password_md5.value !== '') {
        d.password_md5.value = md5(d.password_md5.value);
      }
      const filteredSettings = this.removeEmptyValues(d);
      this.$emit('handleAppSetNoFilter', this.appSetting);
      this.$emit('handleAppSetFilter', filteredSettings);
    },
    removeEmptyValues(target) {
      const handler = (obj) => {
        Object.keys(obj).forEach((key) => {
          if (
            obj[key] &&
            typeof obj[key] === "object" &&
            !Array.isArray(obj[key])
          ) {
            this.removeEmptyValues(obj[key]);
            if (obj[key].hasOwnProperty("value") && obj[key].value === "") {
              delete obj[key];
            } else if (Object.keys(obj[key]).length === 0) {
              delete obj[key];
            }
          } else if (Array.isArray(obj[key]) && obj[key].length === 0) {
            delete obj[key];
          }
        });
      };
      handler(target);
      return target;
    },
    setFormRules() {
      this.scanRules1 = {
        scan_continue_normal_internal: {
          value: {
            required: true,
            message: this.$t("message.messageMsg.normalModeTime"),
            trigger: "blur",
          },
        },
      },
        this.scanRules2 = {
          scan_continue_no_data_internal: {
            value: {
              required: true,
              message: this.$t("message.messageMsg.enhancedMode"),
              trigger: "blur",
            },
          },
          scan_continue_with_data_internal: {
            value: {
              required: true,
              message: this.$t("message.messageMsg.enhancedData"),
              trigger: "blur",
            },
          },
        };
    },
    openbarTruDialog() {
      this.spliteBarcodeCopy = { ...this.appSetting.split_barcode };
      this.barcodeTruDialog = true;
    },
    strDialogClose() {
      if (this.changeStr.length != 0) {
        this.changeStr = this.changeStr.filter((item) => {
          return item.isEdit != true;
        });
      }
    },
    scanCloseDialog() {
      this.appscanCopy = {
        scan_continue_internal_mode: {
          type: "int",
          value: "",
        },
        scan_continue_normal_internal: {
          type: "int",
          value: "",
        },
        scan_continue_no_data_internal: {
          type: "int",
          value: "",
        },
        scan_continue_with_data_internal: {
          type: "int",
          value: "",
        },
      };
      this.scandialogVisible = false;
    },
    splitCloseDialog() {
      this.$nextTick(() => {
        this.$refs["splitForm1"].clearValidate();
        this.$refs["splitForm2"].clearValidate();
      });
    },
    addChangeStr() {
      this.changeStr.push({
        replace: "",
        isEdit: true,
        source: "",
      });
    },
    editChangeStr(data) {
      data.isEdit = true;
    },
    okChangeStr(data) {
      if (data.source != "") {
        data.isEdit = false;
      } else {
        this.$message({
          message: this.$t("message.messageMsg.strNoEmpty"),
          type: "warning",
        });
      }
    },
    delChangeStr(data) {
      let i = this.changeStr.indexOf(data);
      this.changeStr.splice(i, 1);
    },
    submitStr() {
      if (this.changeStr.length != 0) {
        let isEditStatus = this.changeStr.some((i) => i.isEdit); // 是否编辑状态
        let isEmptySource = this.changeStr.some((i) => i.source == ""); // 是否源数据为空
        if (isEditStatus) {
          if (!isEmptySource) {
            this.$message.closeAll();
            this.$message.warning(this.$t("message.messageMsg.save"));
          } else {
            this.$message.closeAll();
            this.$message.warning(this.$t("message.messageMsg.strNoEmpty"));
          }
        } else {
          this.stringdialogVisible = false;
          // 保存数据去掉isEdit
          let rArr = [];
          this.changeStr.map(item => {
            rArr.push({ replace: item.replace, source: item.source });
          })
          this.appSetting.replace_string = [...rArr];
          this.changeStr = [];
          this.$message.success(this.$t('messageAdd.appSet.001'))
        }
      } else {
        this.$message.warning(this.$t('messageAdd.appSet.002'));
      }
    },
    changeRadioButton(e) {
      if (e == "FOCUS") {
        this.foucsFlag = true;
        this.broadcastFlag = false;
        this.emukeyFlag = false;
        this.clipboardFlag = false;
      } else if (e == "BROADCAST") {
        this.foucsFlag = false;
        this.emukeyFlag = false;
        this.clipboardFlag = false;
        this.broadcastFlag = true;
      } else if (e == "EMUKEY") {
        this.foucsFlag = false;
        this.emukeyFlag = true;
        this.clipboardFlag = false;
        this.broadcastFlag = false;
      } else if (e == "CLIPBOARD") {
        this.foucsFlag = false;
        this.emukeyFlag = false;
        this.broadcastFlag = false;
        this.clipboardFlag = true;
      } else {
        this.foucsFlag = false;
        this.emukeyFlag = false;
        this.broadcastFlag = false;
        this.clipboardFlag = false;
      }
    },
    // 多条码
    setMulti() {
      if (this.multiCopy.multi_code_gs1128_splicing.value === '' && this.multiCopy.multi_code_normal_splicing.value === '') {
        this.$message.warning(this.$t('messageAdd.appSet.002'))
      } else {
        this.moreCodedialogVisible = false;
        this.appSetting.multi_code_splicing = { ...this.multiCopy };
        this.$message.success(this.$t('messageAdd.appSet.001'))
      }
    },
    // 多条码拼接正常切换开关
    changeNumalMultiCode(val) {
      if (!val) {
        // 关闭
        this.multiCopy.multi_code_normal_splicing.value = val;
        this.multiCopy.multi_code_normal_separator.value = '';
      }
    },
    changeGS128MultiCode(val) {
      if (!val) {
        this.multiCopy.multi_code_gs1128_splicing.value = val;
        this.multiCopy.multi_code_gs1128_separator.value = '';
      }
    },
    handleAppScanChange(val) {
      if (val === 0) {
        // 普通模式
        this.appscanCopy.scan_continue_no_data_internal.value = "";
        this.appscanCopy.scan_continue_with_data_internal.value = "";
      } else {
        this.appscanCopy.scan_continue_normal_internal.value = "";
      }
    },
    // 循环扫描
    setCircleScan() {
      // 普通模式
      if (this.appscanCopy.scan_continue_internal_mode.value === "") {
        this.$message.warning(this.$t('messageAdd.appSet.002'))
      } else {
        if (this.appscanCopy.scan_continue_internal_mode.value === 0) {
          if (!this.appscanCopy.scan_continue_normal_internal.value || !this.isNumeric(this.appscanCopy.scan_continue_normal_internal.value)) {
            this.$message.closeAll();
            this.$message.warning(this.$t('messageAdd.appSet.003'));
            return;
          }
        }
        // 增强模式
        if (this.appscanCopy.scan_continue_internal_mode.value === 1) {
          // 检查两个值中至少有一个存在且为数字
          let hasValidValue = false;
          if (this.appscanCopy.scan_continue_no_data_internal.value && this.isNumeric(this.appscanCopy.scan_continue_no_data_internal.value)) {
            hasValidValue = true;
          }
          if (this.appscanCopy.scan_continue_with_data_internal.value && this.isNumeric(this.appscanCopy.scan_continue_with_data_internal.value)) {
            hasValidValue = true;
          }
          if (!hasValidValue) {
            this.$message.closeAll();
            this.$message.warning(this.$t('messageAdd.appSet.004'));
            return;
          }
        }
        // 更新设置并关闭对话框
        this.appSetting.scan_continue_internal_params = { ...this.appscanCopy };
        this.scandialogVisible = false;
        this.$message.success(this.$t('messageAdd.appSet.001'))

      }

    },
    isNumeric(value) {
      return /^\-?\d+(\.\d+)?$/.test(value);
    },
    handleSpliteBarcodeChange() {
      // 当值为普通模式时，清空增强模式数据
      if (this.spliteBarcodeCopy.split_barcode_mode.value === 0) {
        this.spliteBarcodeCopy.start_index.value = "";
        this.spliteBarcodeCopy.end_index.value = "";
      }
      // 当值为增强模式时，清空普通模式数据
      if (this.spliteBarcodeCopy.split_barcode_mode.value === 1) {
        this.spliteBarcodeCopy.start_char.value = "";
        this.spliteBarcodeCopy.end_char.value = "";
      }
    },
    // 条码截断
    submitBarTru() {
      if (this.spliteBarcodeCopy.split_barcode_mode.value === '') {
        this.$message.closeAll();
        this.$message.warning(this.$t('messageAdd.appSet.002'));
        return;
      }
      if (this.spliteBarcodeCopy.split_barcode_mode.value === 0) {
        if (this.spliteBarcodeCopy.start_index.value == '' || this.spliteBarcodeCopy.end_index.value == '') {
          this.$message.closeAll();
          this.$message.error(this.$t('messageAdd.scanTool.003'));
        } else {
          if (this.spliteBarcodeCopy.start_index.value * 1 > this.spliteBarcodeCopy.end_index.value * 1) {
            this.$message.closeAll();
            this.$message({
              message: this.$t("message.messageMsg.sGreaterEposition"),
              type: "warning",
            });
          } else {
            this.appSetting.split_barcode = { ...this.spliteBarcodeCopy };
            this.barcodeTruDialog = false;
            this.$message.closeAll();
            this.$message.success(this.$t('messageAdd.appSet.001'))
          }
        }
      } else if (this.spliteBarcodeCopy.split_barcode_mode.value === 1) {
        if (this.spliteBarcodeCopy.start_char.value == '' || this.spliteBarcodeCopy.end_char.value == '') {
          this.$message.closeAll();
          this.$message.error(this.$t('messageAdd.scanTool.004'));
        } else {
          this.appSetting.split_barcode = { ...this.spliteBarcodeCopy };
          this.barcodeTruDialog = false;
          this.$message.closeAll();
          this.$message.success(this.$t('messageAdd.appSet.001'))
        }
      }
    },
    openScanDialog() {
      if (this.appSetting.scan_continue_internal_params) {
        this.appscanCopy = { ...this.appSetting.scan_continue_internal_params };
      }
      this.scandialogVisible = true;
    },
    openStringDialog() {
      this.changeStr = this.appSetting.replace_string.map(item => ({ replace: item.replace, source: item.source, isEdit: false }));
      this.stringdialogVisible = true;
    },
    openMoreCodeDialog() {
      this.moreCodedialogVisible = true;
    },
    clearAllData() {
      this.appscanCopy = {
        scan_continue_internal_mode: {
          type: "int",
          value: "",
        },
        scan_continue_normal_internal: {
          type: "int",
          value: "",
        },
        scan_continue_no_data_internal: {
          type: "int",
          value: "",
        },
        scan_continue_with_data_internal: {
          type: "int",
          value: "",
        },
      },
      // 多条码
      this.multiCopy = {
        multi_code_normal_splicing: {
          type: "boolean",
          value: "",
        },
        multi_code_normal_separator: {
          type: "string",
          value: "",
        },
        multi_code_gs1128_splicing: {
          type: "boolean",
          value: "",
        },
        multi_code_gs1128_separator: {
          type: "string",
          value: "",
        },
      },
      // 条码截断
      this.spliteBarcodeCopy = {
        split_barcode_mode: {
          type: "int",
          value: "",
        },
        start_index: {
          type: "int",
          value: "",
        },
        end_index: {
          type: "int",
          value: "",
        },
        start_char: {
          type: "string",
          value: "",
        },
        end_char: {
          type: "string",
          value: "",
        },
      },
      this.pwd = ""
      this.changeStr = []
      this.$emit('allAppDataDeleted');
    }
  }
}
</script>